import Vue from 'vue'
import App from './App.vue'
import { Divider, Carousel, CarouselItem} from 'element-ui';
// import 'element-ui/lib/theme-chalk/index.css'

Vue.config.productionTip = false
Vue.use(Divider)
Vue.use(Carousel)
Vue.use(CarouselItem)

new Vue({
  render: h => h(App)
}).$mount('#app')
